import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Logo from '../components/Logo';

const PrivacyPolicy: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="mb-8">
          <Link to="/" className="inline-flex items-center text-gray-600 hover:text-gray-900">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back to Home
          </Link>
        </div>
        
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <div className="flex justify-center mb-8">
            <Logo />
          </div>

          <h1 className="text-3xl font-bold mb-8 text-center">Privacy Policy</h1>
          
          <div className="space-y-8">
            <section>
              <h2 className="text-xl font-semibold mb-3">Information Collection and Use</h2>
              <p className="text-gray-600">
                SmartiStat collects information necessary to provide our automated SPD & OR workflow solutions. We collect only information that is voluntarily shared via our platform, APIs, or direct contact. We will not sell or rent this information to anyone.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Healthcare Data Protection</h2>
              <p className="text-gray-600">
                As a healthcare technology provider, SmartiStat complies with all applicable healthcare regulations, including HIPAA. We implement industry-standard safeguards to protect Protected Health Information (PHI) and maintain the confidentiality of all patient data.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Data Sharing</h2>
              <p className="text-gray-600">
                SmartiStat only shares your information with authorized business partners as required to deliver our services. We will not voluntarily share your information with third parties without prior authorization, except when required by law or to protect rights, property, or safety.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Security Measures</h2>
              <p className="text-gray-600">
                We employ comprehensive technical, administrative, and physical safeguards to protect your information, including encryption, access controls, and automated monitoring systems. Our platform is designed with privacy and security as foundational elements.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Data Retention</h2>
              <p className="text-gray-600">
                We retain data only as long as necessary to provide our services or as required by law. Upon termination of services, data will be securely disposed of according to our data retention schedule.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Your Rights</h2>
              <p className="text-gray-600">
                You have the right to access, correct, or request deletion of your information. For questions about our privacy practices or to exercise your rights, contact our Privacy Officer at privacy@smartistat.com.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Policy Updates</h2>
              <p className="text-gray-600">
                We may update this policy occasionally. Changes will be posted on our website with the effective date. Continued use of our services after changes constitutes acceptance of the updated policy.
              </p>
            </section>

            <div className="text-sm text-gray-500 pt-8 border-t">
              Last Updated: May 4, 2025
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;